import { LangEnum } from "@/constants/constants";
import { HttpClient } from "./HttpClient";

export class BaseAPIClient {
  protected httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  protected async callApiWithEnglish<T>(data: {
    endpoint: string;
    options: RequestInit;
    queryParams?: Record<string, string | number | boolean>;
    body?: Record<string, string | number | boolean | object>;
    addToken?: boolean;
    lang?: string;
    dialect?: string;
  }) {
    const response = await this.httpClient.request<T>(data);

    // TODO: Remove this once the API returns the English title. Currently, we are making an additional API call to get the English title for URL slugs.
    let englishResponse: T;
    if (data.lang == LangEnum.EN) {
      englishResponse = response;
    } else {
      englishResponse = await this.httpClient.request<T>({
        ...data,
        lang: LangEnum.EN,
      });
    }

    return [response, englishResponse];
  }
}
